/**
 * @file 全局枚举注入
 * @description 在应用启动时注入全局枚举,使其无需 import 即可使用
 */

import {TaskState as _TaskState, TaskStage as _TaskStage} from './interface/enums';

// 注入到全局 window 对象
if (typeof window !== 'undefined') {
    (window as any).TaskState = _TaskState;
    (window as any).TaskStage = _TaskStage;
}

// 注入到全局作用域 (Node.js 环境)
if (typeof global !== 'undefined') {
    (global as any).TaskState = _TaskState;
    (global as any).TaskStage = _TaskStage;
}

// 确保模块可以被导入
export {};
